import React from 'react';
import { Link } from 'react-router-dom';

const DeleteAccount: React.FC = () => {
  return (
    <div className="iframe-page">
      <h1 className="page-title">Delete Account</h1>
      <p className="page-subtitle" style={{ marginBottom: '1rem' }}>
        Request permanent deletion of your Bye For Now account. We&apos;ll process your request as soon as possible.
      </p>
      <div className="iframe-wrapper">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSeT1z_nGc5iRFpdlzZW_u0uRMqTG13esiJkhHYNZnFe8Q24Tg/viewform?embedded=true"
          title="Bye For Now Delete Account Form"
          width="640"
          height="472"
        >
          Loading…
        </iframe>
      </div>
      <Link to="/" className="page-back-link" style={{ marginTop: '1.5rem' }}>
        ← Back to home
      </Link>
    </div>
  );
};

export default DeleteAccount;
